<section class="chat-card">
    <h5 class="header4-text"><em class="icon-ai-black"></em> <span>Need More Details?</span></h5>
    <p class="description">Ask AI-powered <a href="/insightful-chat" target="_blank">Insightful Chat</a> about any topic related to semiconductor intelligence.</p>
    <form class="chat-form" (submit)="onSubmit($event)">
        <input
            type="text"
            placeholder="Ask me about all things semiconductor"
            [(ngModel)]="chatQuery"
            name="chatQuery"
        />
        <button type="submit" class=""><em class="icon-send"></em></button>
    </form>
</section>